<template>
  <div class="box">
    <div class="field">
      <label class="label">Event to be added</label>
      <div class="control">
        <div class="select">
          <select v-model="selected_event">
            <option v-for="(event_row, index) in event_list" :key="index" :value="index" v-text="event_row.event_title"></option>
          </select>
        </div>
      </div>
    </div>
    <div class="field is-grouped is-grouped-left">
      <div class="control">
        <button class="button is-success" type="button" @click="counter_tab = 0">Event Ticket</button>
      </div>
      <div class="control">
        <button class="button is-success" type="button" @click="counter_tab = 1">Complimentary Ticket</button>
      </div>
    </div>
    <div class="field">
      <label class="label">Add Tickets for All Counter</label>
      <div class="control">
        <money :class="{'input': true}" v-model="tickets" v-bind="number_format"></money>
      </div>
    </div>
    <div class="field is-grouped">
      <div class="control">
        <button class="button is-link" type="button" @click="addToAllCounter()">Add to All Counter</button>
      </div>
      <div class="control">
        <button class="button is-warning" type="button" @click="getModalConfirmation('Service Task', 'Are you sure want to modify all counter tickets for this event?', 'modify_to_all_counter')">Modify to All Counter</button>
      </div>
      <div class="control">
        <button class="button is-danger" type="button" @click="getModalConfirmation('Service Task', 'Are you sure want to clear all counter tickets for this event?', 'clear_to_all_counter')">Clear to All Counter</button>
      </div>
    </div>
    <div class="field is-grouped is-grouped-right">
      <div class="control">
        <button class="button is-success" type="button" @click="submitData()">Update Data</button>
      </div>
    </div>
    <h3 class="title is-3" v-show="counter_tab === 0">Event Ticket</h3>
    <table class="table is-fullwidth" v-show="counter_tab === 0">
      <tr>
        <th>Counter</th>
        <th>Active / Non Active</th>
        <th v-for="(event_row, index) in event_list" :key="index" v-text="event_row.event_title"></th>
      </tr>
      <tr>
        <td>Total Tickets</td>
        <td></td>
        <td v-for="(event_row, index) in event_list" :key="index" v-text="event_row.event_tickets"></td>
      </tr>
      <tr v-for="(counter_row, index) in counter_list" :key="index">
        <td v-text="counter_row.counter_title"></td>
        <td>
          <switches v-model="counter_list[index].active" theme="bulma" color="primary" text-enabled="Active" text-disabled="Not Active"></switches>
        </td>
        <event-service-counter-row v-for="(counter_event_row, index_counter_event) in counter_row.event_service" :key="index_counter_event" :value-row="counter_event_row" :counter-active="counter_row.active" :index-parent="index" :index-counter-event="index_counter_event"></event-service-counter-row>
      </tr>
    </table>
    <h3 class="title is-3" v-show="counter_tab === 1">Complimentary Ticket</h3>
    <table class="table is-fullwidth" v-show="counter_tab === 1">
      <tr>
        <th>Counter</th>
        <th>Active / Non Active</th>
        <th v-for="(event_row, index) in event_complimentary_list" :key="index" v-text="event_row.event_title"></th>
      </tr>
      <tr>
        <td>Total Tickets</td>
        <td></td>
        <td v-for="(event_row, index) in event_complimentary_list" :key="index" v-text="event_row.event_tickets"></td>
      </tr>
      <tr v-for="(counter_row, index) in counter_complimentary_list" :key="index">
        <td v-text="counter_row.counter_title"></td>
        <td>
          <switches v-model="counter_complimentary_list[index].active" theme="bulma" color="primary" text-enabled="Active" text-disabled="Not Active"></switches>
        </td>
        <event-service-counter-row v-for="(counter_event_row, index_counter_event) in counter_row.event_service" :key="index_counter_event" :value-row="counter_event_row" :counter-active="counter_row.active" :index-parent="index" :index-counter-event="index_counter_event"></event-service-counter-row>
      </tr>
    </table>
    <update-tickets-modal :update-tickets-modal-flag="update_tickets_modal_flag" :props-tickets="tickets" :index-parent="index_parent" :index-counter-event="index_counter_event"></update-tickets-modal>
    <confirmation-modal :data-modal="modal_confirmation_data" @confirm-event="confirmHub"></confirmation-modal>
  </div>
</template>

<script>
import {Money} from 'v-money'
import Switches from 'vue-switches'
import EventServiceCounterRow from '@/pages/panel/task/components/EventServiceCounterRow'
import UpdateTicketsModal from '@/pages/panel/task/components/UpdateTicketsModal'
import {ModalConfirmation} from '@/library/mixins/local/ModalConfirmation'

export default {
  mixins: [ModalConfirmation],
  data () {
    return {
      selected_event: 0,
      event_list: [],
      counter_list: [],
      update_tickets_modal_flag: false,
      tickets: 0,
      index_parent: '',
      index_counter_event: '',
      event_bus_add_minus_tickets: '',
      event_bus_modify_tickets: '',
      number_format: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      event_complimentary_list: [],
      counter_complimentary_list: [],
      counter_tab: 0
    }
  },
  components: {
    EventServiceCounterRow,
    Money,
    UpdateTicketsModal,
    Switches
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
    this.checkFrontdeskTeam()
    this.getEvent()
    this.getEventServiceCounter()
  },
  mounted () {
    var self = this
    this.event_bus_add_minus_tickets = this.$geb.getFilteredBus({id: 'add-minus-tickets'}).subscribe(eventData => {
      if (this.counter_tab === 0) {
        if (eventData.flag === '-') {
          self.counter_list[eventData.index_parent].event_service[eventData.index_counter_event].tickets -= 1
        } else if (eventData.flag === '+') {
          self.counter_list[eventData.index_parent].event_service[eventData.index_counter_event].tickets += 1
        }
      } else if (this.counter_tab === 1) {
        if (eventData.flag === '-') {
          self.counter_complimentary_list[eventData.index_parent].event_service[eventData.index_counter_event].tickets -= 1
        } else if (eventData.flag === '+') {
          self.counter_complimentary_list[eventData.index_parent].event_service[eventData.index_counter_event].tickets += 1
        }
      }
    })

    this.event_bus_modify_tickets = this.$geb.getFilteredBus({id: 'modify-tickets'}).subscribe(eventData => {
      var objectData = {}
      if (this.counter_tab === 0) {
        if (eventData.action === 'edit') {
          // Modal for edit
          self.update_tickets_modal_flag = true
          self.index_parent = eventData.index_parent
          self.index_counter_event = eventData.index_counter_event
          self.tickets = self.counter_list[eventData.index_parent].event_service[eventData.index_counter_event].tickets
        } else if (eventData.action === 'clear') {
          objectData = {
            index_parent: eventData.index_parent,
            index_counter_event: eventData.index_counter_event
          }
          self.getModalConfirmation('Clear Event Ticket', 'Are you sure want to clear this tickets?', 'event_ticket', objectData)
        } else if (eventData.action === 'update') {
          self.counter_list[eventData.index_parent].event_service[eventData.index_counter_event].tickets = eventData.tickets
          self.update_tickets_modal_flag = false
          self.tickets = 0
          self.index_parent = ''
          self.index_counter_event = ''
        } else if (eventData.action === 'cancel') {
          self.update_tickets_modal_flag = false
          self.tickets = 0
          self.index_parent = ''
          self.index_counter_event = ''
        }
      } else if (this.counter_tab === 1) {
        if (eventData.action === 'edit') {
          // Modal for edit
          self.update_tickets_modal_flag = true
          self.index_parent = eventData.index_parent
          self.index_counter_event = eventData.index_counter_event
          self.tickets = self.counter_complimentary_list[eventData.index_parent].event_service[eventData.index_counter_event].tickets
        } else if (eventData.action === 'clear') {
          objectData = {
            index_parent: eventData.index_parent,
            index_counter_event: eventData.index_counter_event
          }
          self.getModalConfirmation('Clear Complimentary Ticket', 'Are you sure want to clear this tickets?', 'complimentary_ticket', objectData)
        } else if (eventData.action === 'update') {
          self.counter_complimentary_list[eventData.index_parent].event_service[eventData.index_counter_event].tickets = eventData.tickets
          self.update_tickets_modal_flag = false
          self.tickets = 0
          self.index_parent = ''
          self.index_counter_event = ''
        } else if (eventData.action === 'cancel') {
          self.update_tickets_modal_flag = false
          self.tickets = 0
          self.index_parent = ''
          self.index_counter_event = ''
        }
      }
    })
  },
  methods: {
    // Untuk cek apakah TL ini adalah team Frontdesk atau bukan
    checkFrontdeskTeam () {
      var self = this
      self.flyGetSession('task/check_frontdesk_team').then(function (response) {
        if (response.data.response_code === 1) {
          self.frontdesk_team = response.data.data.frontdesk_team
          if (self.frontdesk_team !== 1) {
            self.$router.push('/panel/profile')
          }
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        self.errorMessage(response)
      })
    },
    confirmHub (confirmData) {
      console.log(confirmData)
      if (confirmData.flag === true) {
        switch (confirmData.label) {
          case 'modify_to_all_counter':
            this.modifyToAllCounter()
            break
          case 'clear_to_all_counter':
            this.clearToAllCounter()
            break
          case 'event_ticket':
            this.counter_list[confirmData.data.index_parent].event_service[confirmData.data.index_counter_event].tickets = 0
            break
          case 'complimentary_ticket':
            this.counter_complimentary_list[confirmData.data.index_parent].event_service[confirmData.data.index_counter_event].tickets = 0
            break
          default:
            break
        }
      }
      this.clearModalConfirmationData()
    },
    // To check team task exists
    checkTeamTask () {
      var self = this
      self.flyGetSession('task_service/check_current_task')
      .then(function (response) {
        if (response.data.response_code === 1) {
          // Current task exists
        } else {
          // Current task not exists, redirect to Create Task
          self.$router.push('/panel/task')
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    // To get list event
    getEvent () {
      var self = this
      self.flyGetSession('task_service/event')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.event_list = response.data.data.event
          self.event_complimentary_list = response.data.data.event_complimentary
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    // To get list counter
    getEventServiceCounter () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGetSession('task_service/counter')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.counter_list = response.data.data.counter_list
          self.counter_complimentary_list = response.data.data.counter_complimentary_list
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    // Add tickets to all active counter
    addToAllCounter () {
      var index = 0
      if (this.counter_tab === 0) {
        for (index in this.counter_list) {
          if (this.counter_list[index].active === true) {
            this.counter_list[index].event_service[this.selected_event].tickets += parseInt(this.tickets)
          }
        }
      } else if (this.counter_tab === 1) {
        for (index in this.counter_complimentary_list) {
          if (this.counter_complimentary_list[index].active === true) {
            this.counter_complimentary_list[index].event_service[this.selected_event].tickets += parseInt(this.tickets)
          }
        }
      }
    },
    // Modify tickets to all active counter
    modifyToAllCounter () {
      var index = 0
      if (this.counter_tab === 0) {
        for (index in this.counter_list) {
          if (this.counter_list[index].active === true) {
            this.counter_list[index].event_service[this.selected_event].tickets = parseInt(this.tickets)
          }
        }
      } else if (this.counter_tab === 1) {
        for (index in this.counter_complimentary_list) {
          if (this.counter_complimentary_list[index].active === true) {
            this.counter_complimentary_list[index].event_service[this.selected_event].tickets = parseInt(this.tickets)
          }
        }
      }
    },
    // Clear tickets to all active counter
    clearToAllCounter () {
      var index = 0
      if (this.counter_tab === 0) {
        for (index in this.counter_list) {
          if (this.counter_list[index].active === true) {
            this.counter_list[index].event_service[this.selected_event].tickets = 0
          }
        }
      } else if (this.counter_tab === 1) {
        for (index in this.counter_complimentary_list) {
          if (this.counter_complimentary_list[index].active === true) {
            this.counter_complimentary_list[index].event_service[this.selected_event].tickets = 0
          }
        }
      }
    },
    // To active a counter
    /*
    activateCounter (index, flag) {
      this.counter_list[index].active = flag
      this.counter_complimentary_list[index].active = flag
    },
    */
    submitData () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('task_service/insert', {
        counter_list: this.counter_list,
        counter_complimentary_list: this.counter_complimentary_list
      }).then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.$geb.emit({id: 'alert_modal', title: 'Success!', content: 'Data anda sudah masuk!', button_text: 'OK'})
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        self.errorMessage(response)
      })
    }
  },
  beforeDestroy () {
    if (this.event_bus_add_minus_tickets) {
      this.event_bus_add_minus_tickets.unsubscribe()
    }
    if (this.event_bus_modify_tickets) {
      this.event_bus_modify_tickets.unsubscribe()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/task/Service.vue